module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_17-026d6d401bb800da29504a3f15757d41.png";